import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ESRegulatoryUpdateRedirect from "@/components/LegacyRedirects";

export const Route = createFileRoute("/es/regulatory-updates/")({
  head: () => buildRouteHead("/es/regulatory-updates/", { noIndex: true }),
  component: ESRegulatoryUpdateRedirect,
});

